import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  SalesPack,
  SalesPackDespatchNoteAddRemove,
  SalesPackDetails,
  SalesPackEmailContacts,
  SalesPackReport,
  SalesPacksForDespatchNote,
} from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesPackService extends TmsWebBaseEditCreateService<SalesPack, SalesPackDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesPack', $localize`Sales Pack`);
  }

  createSalesPack(ids: string[]): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/CreateSalesPack`, { ids });
  }

  getSalesPackReport(id: string): Observable<SalesPackReport> {
    return this.httpService.get<SalesPackReport>(`${this.apiUrl}/SalesPackReport/${id}`);
  }

  getSalesPacksForDespatchNote(id: string): Observable<SalesPacksForDespatchNote[]> {
    return this.httpService.get<SalesPacksForDespatchNote[]>(`${this.apiUrl}/SalesPacksForDespatchNote?id=${id}`);
  }

  removeFromSalesDespatchNote(salesPackDespatchNoteAddRemove: SalesPackDespatchNoteAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromSalesDespatchNote`, salesPackDespatchNoteAddRemove);
  }

  addToSalesDespatchNote(salesPackDespatchNoteAddRemove: SalesPackDespatchNoteAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToSalesDespatchNote`, salesPackDespatchNoteAddRemove);
  }

  getSalesPackEmailContacts(id: string): Observable<SalesPackEmailContacts> {
    return this.httpService.get<SalesPackEmailContacts>(`${this.apiUrl}/SalesPackEmailContacts?id=${id}`);
  }

  amendSalesPackItem(model: SalesPacksForDespatchNote): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/AmendSalesPackItem`, model);
  }
}
